export default __webpack_public_path__ + "static/media/180919.37a14d65.jpg";